// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_NORMAL_CONFIRMATION_MODAL
});

export const setConfirmationModal = options => ({
    data: options,
    type: actions.SET_CLAIM_NORMAL_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/confirmation-modal.js